import { useState, useEffect, useRef } from 'react';

const testimonials = [
  {
    name: 'Sophie Martin',
    date: 'Il y a 2 semaines',
    rating: 5,
    text: 'Livraison urgente d\'un canapé 3 places de mon appartement rue de Rivoli (1er) vers Montmartre (18e). Le chauffeur est arrivé en 50 minutes un samedi après-midi, a monté les 3 étages sans ascenseur avec un collègue. Emballage soigné, aucune rayure. Prix annoncé respecté (45€). Je recommande vivement pour les meubles volumineux !',
    avatar: 'SM',
    service: 'Transport de meubles',
    verified: true,
  },
  {
    name: 'Karim Benali',
    date: 'Il y a 1 mois',
    rating: 5,
    text: 'J\'ai utilisé leur service de coursier moto pour récupérer des échantillons urgents à Gare du Nord et les livrer à mon bureau à La Défense (Tour Ariane). Commande passée à 14h30, livrée à 15h20. Le coursier m\'a envoyé un SMS 5 min avant d\'arriver. Suivi GPS en temps réel très pratique. Tarif : 18€. Parfait pour les documents urgents entre Paris et La Défense.',
    avatar: 'KB',
    service: 'Coursier express',
    verified: true,
  },
  {
    name: 'Marie Dupont',
    date: 'Il y a 3 semaines',
    rating: 5,
    text: 'Déménagement d\'un studio de 25m² du quartier Bastille (11e) vers Vincennes (94). Réservé la veille pour le lendemain matin 9h. L\'équipe de 2 personnes est arrivée à l\'heure avec un utilitaire. Tout a été chargé, transporté et déchargé en 2h30. Ils ont même remonté mon lit et ma commode. Total : 120€ tout compris. Excellent rapport qualité-prix comparé aux devis de déménageurs classiques !',
    avatar: 'MD',
    service: 'Petit déménagement',
    verified: true,
  },
  {
    name: 'Thomas Leroy',
    date: 'Il y a 1 semaine',
    rating: 5,
    text: 'Je gère une boutique e-commerce à Pantin (93) et j\'utilise leurs services 3-4 fois par semaine pour livrer des colis clients dans Paris intra-muros. Toujours ponctuels, jamais eu de colis perdu ou abîmé en 3 mois. Les chauffeurs prennent des photos à la livraison. Le service client répond même le dimanche par WhatsApp. Tarifs dégressifs pour les pros : je paie 14€/course au lieu de 19€. Vraiment fiables.',
    avatar: 'TL',
    service: 'Livraison professionnelle',
    verified: true,
  },
  {
    name: 'Fatima El Amrani',
    date: 'Il y a 2 mois',
    rating: 4,
    text: 'Transport d\'un réfrigérateur américain acheté sur Leboncoin à Montreuil (93) jusqu\'à mon appartement à Boulogne-Billancourt (92). Le chauffeur avait un diable et des sangles, il a même aidé à débrancher l\'ancien frigo et à installer le nouveau. Prévu à 15h, arrivé à 15h20 (petit retard mais prévenu par SMS). Prix : 55€. Seul bémol : le retard, sinon service impeccable pour de l\'électroménager lourd.',
    avatar: 'FA',
    service: 'Transport électroménager',
    verified: true,
  },
  {
    name: 'Lucas Petit',
    date: 'Il y a 5 jours',
    rating: 5,
    text: 'Urgence absolue un dimanche soir à 21h : j\'avais oublié des documents contractuels essentiels pour un vol tôt le lundi matin à Roissy CDG Terminal 2E. J\'ai appelé leur numéro, réponse en 2 sonneries. Coursier moto dépêché depuis Aubervilliers, arrivé chez moi à Belleville (20e) en 18 minutes, livraison à l\'aéroport à 22h10. Coût : 65€ (majoration nocturne + distance). Ils m\'ont sauvé la mise. Service exceptionnel !',
    avatar: 'LP',
    service: 'Coursier moto urgent',
    verified: true,
  },
];

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <i
          key={star}
          className={`ri-star-fill text-sm ${
            star <= rating ? 'text-yellow-400' : 'text-gray-300'
          }`}
        ></i>
      ))}
    </div>
  );
}

function GoogleLogo() {
  return (
    <span className="inline-flex items-center gap-1.5 text-sm font-medium text-gray-500">
      <span className="text-[#4285F4] font-bold">G</span>
      <span className="text-[#EA4335] font-bold">o</span>
      <span className="text-[#FBBC05] font-bold">o</span>
      <span className="text-[#4285F4] font-bold">g</span>
      <span className="text-[#34A853] font-bold">l</span>
      <span className="text-[#EA4335] font-bold">e</span>
    </span>
  );
}

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isAutoPlaying) return;
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  useEffect(() => {
    if (scrollRef.current) {
      const card = scrollRef.current.children[activeIndex] as HTMLElement;
      if (card) {
        scrollRef.current.scrollTo({
          left: card.offsetLeft - scrollRef.current.offsetWidth / 2 + card.offsetWidth / 2,
          behavior: 'smooth',
        });
      }
    }
  }, [activeIndex]);

  const averageRating = (
    testimonials.reduce((sum, t) => sum + t.rating, 0) / testimonials.length
  ).toFixed(1);

  const avatarColors = [
    'bg-red-500',
    'bg-amber-500',
    'bg-emerald-500',
    'bg-sky-500',
    'bg-rose-500',
    'bg-teal-500',
  ];

  return (
    <section id="temoignages" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-full px-5 py-2 mb-6 shadow-sm">
            <GoogleLogo />
            <span className="text-gray-400 mx-1">|</span>
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map((s) => (
                <i key={s} className="ri-star-fill text-yellow-400 text-sm"></i>
              ))}
            </div>
            <span className="text-sm font-bold text-gray-800">{averageRating}/5</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Ce que disent nos clients
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Plus de <strong>200 avis vérifiés</strong> de clients réels. Découvrez pourquoi nos clients nous font confiance pour leurs livraisons en Île-de-France.
          </p>
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-14">
          <div className="bg-white rounded-2xl p-5 text-center shadow-sm border border-gray-100">
            <div className="text-3xl font-bold text-gray-900 mb-1">{averageRating}</div>
            <div className="flex justify-center mb-2">
              {[1, 2, 3, 4, 5].map((s) => (
                <i key={s} className="ri-star-fill text-yellow-400 text-xs"></i>
              ))}
            </div>
            <p className="text-xs text-gray-500 font-medium">Note moyenne</p>
          </div>
          <div className="bg-white rounded-2xl p-5 text-center shadow-sm border border-gray-100">
            <div className="text-3xl font-bold text-gray-900 mb-1">200+</div>
            <div className="w-6 h-6 flex items-center justify-center mx-auto mb-2">
              <i className="ri-chat-3-line text-red-500 text-lg"></i>
            </div>
            <p className="text-xs text-gray-500 font-medium">Avis vérifiés</p>
          </div>
          <div className="bg-white rounded-2xl p-5 text-center shadow-sm border border-gray-100">
            <div className="text-3xl font-bold text-gray-900 mb-1">98%</div>
            <div className="w-6 h-6 flex items-center justify-center mx-auto mb-2">
              <i className="ri-thumb-up-line text-green-500 text-lg"></i>
            </div>
            <p className="text-xs text-gray-500 font-medium">Clients satisfaits</p>
          </div>
          <div className="bg-white rounded-2xl p-5 text-center shadow-sm border border-gray-100">
            <div className="text-3xl font-bold text-gray-900 mb-1">5 000+</div>
            <div className="w-6 h-6 flex items-center justify-center mx-auto mb-2">
              <i className="ri-truck-line text-amber-500 text-lg"></i>
            </div>
            <p className="text-xs text-gray-500 font-medium">Livraisons réalisées</p>
          </div>
        </div>

        {/* Testimonials Carousel */}
        <div
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          onMouseEnter={() => setIsAutoPlaying(false)}
          onMouseLeave={() => setIsAutoPlaying(true)}
        >
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`flex-shrink-0 w-[340px] md:w-[380px] snap-center bg-white rounded-2xl p-7 border-2 transition-all duration-300 cursor-pointer ${
                activeIndex === index
                  ? 'border-red-500 shadow-xl scale-[1.02]'
                  : 'border-gray-100 shadow-sm hover:shadow-md hover:border-gray-200'
              }`}
            >
              {/* Header */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div
                    className={`w-11 h-11 ${avatarColors[index % avatarColors.length]} rounded-full flex items-center justify-center text-white font-bold text-sm`}
                  >
                    {testimonial.avatar}
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-900">{testimonial.name}</h4>
                    <p className="text-xs text-gray-400">{testimonial.date}</p>
                  </div>
                </div>
                {testimonial.verified && (
                  <div className="flex items-center gap-1 bg-blue-50 px-2 py-1 rounded-md">
                    <i className="ri-shield-check-fill text-[#4285F4] text-xs"></i>
                    <span className="text-[10px] font-semibold text-[#4285F4]">Vérifié</span>
                  </div>
                )}
              </div>

              {/* Rating */}
              <div className="flex items-center gap-3 mb-4">
                <StarRating rating={testimonial.rating} />
                <span className="text-xs font-medium text-gray-400 bg-gray-50 px-2 py-0.5 rounded-md">
                  {testimonial.service}
                </span>
              </div>

              {/* Text */}
              <p className="text-sm text-gray-700 leading-relaxed mb-4">
                &ldquo;{testimonial.text}&rdquo;
              </p>
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => {
                setActiveIndex(index);
                setIsAutoPlaying(false);
              }}
              className={`rounded-full transition-all duration-300 cursor-pointer ${
                activeIndex === index
                  ? 'w-8 h-3 bg-red-500'
                  : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'
              }`}
              aria-label={`Voir avis ${index + 1}`}
            />
          ))}
        </div>

        {/* Note de transparence */}
        <div className="text-center mt-12">
          <a
            href="https://www.google.fr/search?sca_esv=101ff31f9e3f7929&kgmid=/g/11y_bdx52l&q=Transporteur+express&shndl=30&source=sh/x/loc/hdr/m1/3&kgs=06856b9dce7bc537&shem=shrtn&utm_source=shrtn,sh/x/loc/hdr/m1/3"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-xl px-6 py-3 mb-6 shadow-sm hover:shadow-md transition-all cursor-pointer group"
          >
            <GoogleLogo />
            <span className="text-sm font-semibold text-gray-700 group-hover:text-gray-900">
              Voir tous nos avis sur Google
            </span>
            <i className="ri-external-link-line text-gray-400 text-sm"></i>
          </a>
          <p className="text-xs text-gray-500 max-w-2xl mx-auto">
            Vous avez utilisé nos services ? Laissez-nous un avis sur Google pour aider les futurs clients.
          </p>
        </div>
      </div>
    </section>
  );
}
